import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSalesCategoryFilters, getReportSalesCategoryAction } from "redux/actions/Reports/reportSalesCategory/reportSalesCategoryActions";

export const ReportSalesCategoryView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportSalesCategory }) => reportSalesCategory);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) {
      setSnackbar("Faltan planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportSalesCategoryAction({ startDate, endDate, station, isPdf }))
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Venta Categoría por Cliente" icon={<ReceiptIcon />} >
      {isLoadingComp?.loadingReportSalesCategory ? <LoadingComponent /> :
        <TableInputs
          reducer="reportSalesCategory"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportSalesCategoryFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) =>handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
